/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IImageCardViewProps } from './image-card';

export default (props: IImageCardViewProps) => {
    return (
        <div data-content-type='row' data-appearance='contained' data-element='main'>
            <div
                className='row_campervan_supplies'
                data-enable-parallax={0}
                data-parallax-speed='0.5'
                data-background-images='{}'
                data-background-type='image'
                data-video-loop='true'
                data-video-play-only-visible='true'
                data-video-lazy-load='true'
                data-video-fallback-src
                data-element='inner'
                style={{
                    justifyContent: 'flex-start',
                    display: 'flex',
                    flexDirection: 'column',
                    backgroundPosition: 'left top',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundAttachment: 'scroll',
                    borderStyle: 'none',
                    borderWidth: '1px',
                    borderRadius: '0px',
                    margin: '0px 0px 10px',
                    padding: '10px'
                }}
            >
                <h3
                    data-content-type='heading'
                    data-appearance='default'
                    data-element='main'
                    style={{ textAlign: 'center', borderStyle: 'none', borderWidth: '1px', borderRadius: '0px' }}
                >
                    &nbsp;{props.config.title}
                </h3>
                <div
                    data-content-type='text'
                    data-appearance='default'
                    data-element='main'
                    style={{ borderStyle: 'none', borderWidth: '1px', borderRadius: '0px', margin: '0px', padding: '0px' }}
                >
                    <p style={{ textAlign: 'center' }}>{props.config.description}&nbsp;</p>
                </div>
                <div
                    className='block_campervan_supplies'
                    data-content-type='block'
                    data-appearance='default'
                    data-element='main'
                    style={{ borderStyle: 'none', borderWidth: '1px', borderRadius: '0px', margin: '0px', padding: '0px' }}
                >
                    <div className='widget block block-static-block'>
                        <div data-content-type='row' data-appearance='contained' data-element='main'>
                            <div
                                data-enable-parallax={0}
                                data-parallax-speed='0.5'
                                data-background-images='{}'
                                data-background-type='image'
                                data-video-loop='true'
                                data-video-play-only-visible='true'
                                data-video-lazy-load='true'
                                data-video-fallback-src
                                data-element='inner'
                                style={{
                                    justifyContent: 'flex-start',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    backgroundPosition: 'left top',
                                    backgroundSize: 'cover',
                                    backgroundRepeat: 'no-repeat',
                                    backgroundAttachment: 'scroll',
                                    borderStyle: 'none',
                                    borderWidth: '1px',
                                    borderRadius: '0px',
                                    margin: '0px',
                                    padding: '0px'
                                }}
                            >
                                <div
                                    data-content-type='text'
                                    data-appearance='default'
                                    data-element='main'
                                    style={{
                                        borderStyle: 'none',
                                        borderWidth: '1px',
                                        borderRadius: '0px',
                                        margin: '0px',
                                        padding: '0px'
                                    }}
                                >
                                    <p />
                                    {props.config.cards &&
                                        props.config.cards.map((card, index) => {
                                            return (
                                                <div key={index} className='Content-ImageBlock rectangle'>
                                                    <div className='Background'>
                                                        <img src={card.imageUrl?.src} alt={card.imageUrl?.altText} />
                                                    </div>
                                                    <div className='Text'>
                                                        <div className='TitleWrapper'>
                                                            <span className='Title'>{card.title}</span>
                                                        </div>
                                                        <div className='SubTitle'>{card.description} </div>
                                                        <div className='Button'>
                                                            <a href={card.button?.url?.destinationUrl}>{card.button?.text} </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    <p />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
